import React from 'react'

const URLNotFound = () => {
  return (
    <div>
      Error 404 : URL Not Found!
    </div>
  )
}

export default URLNotFound
